import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface Step {
  title: string;
  status: 'active' | 'inactive';
}

@Component({
  selector: 'papi-stepper',
  templateUrl: './stepper.component.html',
})
export class StepperComponent {
  @Input() steps: Array<Step> = [];
  @Output() stepChange = new EventEmitter<number>();

  currentStepIndex: number = 0;

  setActiveStep(index: number) {
    this.currentStepIndex = index;
    this.stepChange.emit(this.currentStepIndex);
  }

  nextStep() {
    if (this.currentStepIndex < this.steps.length - 1) {
      this.currentStepIndex++;
      this.stepChange.emit(this.currentStepIndex);
    }
  }

  previousStep() {
    if (this.currentStepIndex > 0) {
      this.currentStepIndex--;
      this.stepChange.emit(this.currentStepIndex);
    }
  }
}
